import { useState } from 'react'

const usePreference = (preferenceName, defaultValue, transform) => {
	let value = localStorage.getItem(preferenceName) || defaultValue
	if (transform) {
		try {
			value = transform(value)
		} catch (_) {}
	}
	const [preference, setPreference] = useState(value)
	const setAndSavePreference = (callback) => {
		setPreference((prev) => {
			let nextValue = callback(prev)
			try {
				if (nextValue) {
					localStorage.setItem(preferenceName, nextValue)
				} else {
					localStorage.removeItem(preferenceName)
				}
			} catch (_) {}
			return transform ? transform(nextValue) : nextValue
		})
	}
	return [preference, setAndSavePreference]
}

export default usePreference
